var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('main',[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }